import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReportTemplateListComponent = get(
  'components.reportTemplateList'
);

export const getShowDeleteModal = createSelector(
  getReportTemplateListComponent,
  get('showDeleteModal')
);
